import React, { useEffect } from 'react';
import Main from '../Dashboard/Main';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Tooltip,
} from '@mui/material';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import Groups3Icon from '@mui/icons-material/Groups3';
import Person3Icon from '@mui/icons-material/Person3';
import InventoryIcon from '@mui/icons-material/Inventory';
import CategoryIcon from '@mui/icons-material/Category';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataCounts } from '../../Redux/UserRedux.js';

function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { dataCounts } = useSelector((state) => state.userRedux);


  useEffect(() => {
    dispatch(fetchDataCounts(user.userId));
  }, [dispatch, user.userId]);

  // Dynamically setting the count from dataCounts or default to 0
  const DashboardCard = [
    {
      list: 'Orders',
      Icon: <ListAltOutlinedIcon />,
      no: dataCounts?.orders || '-',
      path: '/myAccount/orders',
    },
  ];

  if (user?.role === 'admin') {
    DashboardCard.push(
      {
        list: 'Products',
        Icon: <InventoryIcon />,
        no: dataCounts?.products || '-',
        path: '/myAccount/addproducts',
      },
      {
        list: 'Category',
        Icon: <CategoryIcon />,
        no: dataCounts?.category || '-',
        path: '/myAccount/addcategory',
      },
      {
        list: 'Sellers',
        Icon: <Person3Icon />,
        no: dataCounts?.sellers || '-',
        path: '/myAccount/seller',
      },
      {
        list: 'Entrepreneurs',
        Icon: <HandshakeIcon />,
        no: dataCounts?.partners || '-',
        path: '/myAccount/clientsDetails',
      },
      {
        list: 'Buyers',
        Icon: <Groups3Icon />,
        no: dataCounts?.buyers || '-',
        path: '/myAccount/buyers',
      }
    );
  }
  if (user?.role === 'seller') {
    DashboardCard.push({
      list: 'Products',
      Icon: <InventoryIcon />,
      no: dataCounts?.products || '-',
      path: '/myAccount/addproducts',
    });
  }

  const handleCardClick = (path) => {
    navigate(path);
  };

  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <Grid container spacing={3}>
          {DashboardCard.map((card, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Tooltip title={card.list}>
                <Card
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    bgcolor: '#fcfff3',
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                    borderRadius: '8px',
                    '&:hover': {
                      boxShadow: '0 6px 15px rgba(0, 0, 0, 0.4)',
                    },
                  }}
                  onClick={() => handleCardClick(card.path)}
                >
                  <CardContent>
                    <Grid container alignItems='center' spacing={2}>
                      <Grid item xs={6} sm={6}>
                        <Box sx={{ display: 'flex', justifyContent: 'left' }}>
                          <IconButton
                            sx={{
                              color: '#000',
                              width: 40,
                              height: 40,
                              padding: 0,
                            }}
                          >
                            {React.cloneElement(card.Icon, {
                              sx: {
                                fontSize: 'inherit',
                                width: '100%',
                                height: '100%',
                              },
                            })}
                          </IconButton>
                        </Box>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <Grid item xs={12} sm={12}>
                          <Box
                            sx={{ display: 'flex', justifyContent: 'center' }}
                          >
                            <Typography variant='h4' component='div'>
                              {card.no}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <Box
                            sx={{ display: 'flex', justifyContent: 'center' }}
                          >
                            <Typography variant='h6' component='div' noWrap>
                              {card.list}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Tooltip>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Main>
  );
}

export default Dashboard;
